<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent="" scrollable  max-width="600px">
                <v-card :style="($vuetify.breakpoint.mdAndDown) ? 'width:auto;' : 'min-width:300px;max-width:600px;'">
                    <v-card-title>{{ formTitle }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="height: auto;">
                        <br>
                        <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                        <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>

                        <v-form id="form_add_maintenance" ref="form" v-model="valid" lazy-validation>
                            
                            <v-text-field
                                v-model="current_date"
                                label="Date and Time"
                                append-icon="mdi-calendar-today"
                                readonly
                                filled
                            ></v-text-field>

                            <v-text-field
                                v-model="device_name"
                                label="Device"
                                append-icon="mdi-monitor-star"
                                readonly
                                filled
                            ></v-text-field>

                            <!--
                            <v-text-field v-if="last_maintenance !== null"
                                v-model="last_maintenance_entrances"
                                label="Entrances since last maintenance"
                                append-icon="mdi-counter"
                                readonly
                                filled
                            ></v-text-field> 
                            -->

                            
                            <v-text-field v-if="last_maintenance !== null"
                                v-model="last_maintenance"
                                label="Last maintenance"
                                append-icon="mdi-wrench"
                                readonly
                                filled
                            ></v-text-field>                            

                            <v-text-field
                                v-model="servicemen"
                                label="Servicemen"
                                append-icon="mdi-account-box"
                                readonly
                                filled
                            ></v-text-field>

                            <v-textarea
                            outlined
                            name="input-7-4"
                            label="Notes"
                            v-model="note"
                            counter
                            required
                            :rules="[]"
                            clearable
                            rows="10"
                            ></v-textarea>
                            
                        </v-form>

                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text id="form--card--actions--mobile" v-if="$vuetify.breakpoint.xsOnly">
                        <v-btn block outlined style="margin-bottom:15px;" @click="submitForm()" color="success" :disabled="disableSubmit" :loading="loading"><v-icon left>mdi-arrow-right</v-icon>{{ submitText }}</v-btn>
                        <v-btn block outlined style="" @click="cancel()" color="error" :disabled="loading"><v-icon left>mdi-close</v-icon>{{ cancelText }}</v-btn>
                    </v-card-text>
                    <v-card-text id="form--card--actions--desktop" v-else>
                        <v-btn @click="submitForm()" color="success" text :disabled="disableSubmit" :loading="loading"><v-icon left>mdi-arrow-right</v-icon>{{ submitText }}</v-btn>
                        <v-btn @click="cancel()" color="error" text :disabled="loading"><v-icon left>mdi-close</v-icon>{{ cancelText }}</v-btn>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import { formatDate, getCurrentDate, getCurrentDateTime } from '@/helpers/utilities.js'
import { EventBus } from '@/main.js'
const FormValidationMessages = () => import('@/components/FormValidationMessages.vue')
const FormSubmitMessages = () => import('@/components/FormSubmitMessages.vue')

export default {
    name: 'add-maintenance-dialog',

    components: {
        FormValidationMessages,
        FormSubmitMessages
    },

    data: () => ({
        valid: false,
        dialog: false,
        loading: false,
        item: {},
        disableSubmit: false,


        note: null,
        servicemen: null,
        device_name: null,
        last_maintenance: null,
        last_maintenance_entrances: null,
        current_date: null,

        cashier_uuid: null,
        cashier_nr: null,
        business_premise_id: null,
        business_premise_uuid: null,
        organization_id: null,
        maintenance_schedule_group_id: null,
        maintenance_schedule_group_uuid: null,

        formTitle: "Add maintenance record",
        submitText: "Save",
        cancelText: 'Cancel',

        backendMessages: [],
        backendErrorMessages: [],
        backendValidationMessages:[],

        note_rules: [v => !!v || 'Field notes is required'],

        currentDate: null,
    }),

    watch: {

    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        apiMessages() {
            return this.backendMessages;
        },

        apiErrorMessages() {
            return this.backendErrorMessages 
        },

        apiValidationMessages() {
            return this.backendValidationMessages
        },
    },

    methods: {
        submitForm() {
            let vm = this
            this.item = {}
            
            //this.demoSubmit()
            if(this.$refs.form.validate()) {
                vm.cancelText = "Cancel"
                vm.loading = true
                vm.backendValidationMessages = []
                vm.backendMessages = []
                vm.backendErrorMessages = []

                vm.$store.dispatch('CREATE_MAINTENANCE', {
                    business_premise_id: vm.business_premise_id,
                    business_premise_uuid: vm.business_premise_uuid,
                    organization_id: vm.organization_id,
                    maintenance_schedule_group_id: vm.maintenance_schedule_group_id,
                    maintenance_schedule_group_uuid: vm.maintenance_schedule_group_uuid,
                    note: vm.note
                })  
                .then(response => {
                    //window.console.log("### AddMaintenanceDialog@submitForm")
                    //window.console.log(response.data)

                    vm.backendMessages.push('Maintenance record has been successfully saved in the system.');
                    vm.disableSubmit = true
                    vm.cancelText = "Close"
                })
                .catch(error => {
                    console.log('CREATE MAINTENANCE error')
                    console.log(error)

                    if(error.response.status === 422) {
                        window.console.log(error.response.data.errors)
                        for (const property in error.response.data.errors) {
                            //window.console.log(`${property}: ${error.response.data.errors[property]}`);
                            var propertyData = error.response.data.errors[property];
                            //window.console.log(propertyData);
                            propertyData.forEach(message => {
                                vm.backendValidationMessages.push(message);
                            })
                        }
                    } else {
                        vm.backendErrorMessages.push('Ups... something went wront. Please try again.')
                    }
                })
                .finally(() => {
                    setTimeout(() => {
                        vm.loading = false
                    }, 600)
                })
            }

        },

        cancel() {
            this.dialog = false;
            this.clearForm()

            EventBus.$emit('refresh_dt_maintenance_schedule_group', null);
        },

        clearForm() {
            this.formTitle = "Add maintenance record";
            this.currentDate = null
            this.servicemen = null
            this.device_name = null
            this.last_maintenance = null
            this.last_maintenance_entrances = null
            this.cashier_nr = null
            this.cashier_uuid = null
            this.business_premise_id = null
            this.business_premise_uuid = null
            this.organization_id = null
            this.maintenance_schedule_group_id = null
            this.maintenance_schedule_group_uuid = null
            this.note = null
            this.loading = false
            this.disableSubmit = false
            this.cancelText = "Cancel"

            this.clearBackendMessages()
            this.$refs.form.resetValidation();
        },

        clearBackendMessages() {
            this.backendValidationMessages = []
            this.backendMessages = []
            this.backendErrorMessages = []
        },

        setupData() {
            let lastMaintenanceText = null

            if(this.item.last_maintenance) {
                let lmTimestamp = this.item.last_maintenance.service_completed_at_formatted;
                
                lastMaintenanceText = this.item.last_maintenance.servicemen;

                if(lmTimestamp !== null && lmTimestamp !== "") {
                    //lastMaintenanceText = lastMaintenanceText + " (" + lmTimestamp + ") [ ID: " + this.item.last_maintenance.id + " ]"
                    lastMaintenanceText = lastMaintenanceText + " (" + lmTimestamp + ") [ TS: " + this.item.last_maintenance.service_completed_at_formatted + "(ID:)" + this.item.id+ " ]"
                }
            }

            this.cashier_nr = this.item.cashier_nr;
            this.cashier_uuid = this.item.uuid
            this.business_premise_id = this.item.business_premise_id
            this.business_premise_uuid = this.item.business_premise_uuid
            this.organization_id = this.item.organization_id
            this.maintenance_schedule_group_id = this.item.id
            this.maintenance_schedule_group_uuid = this.item.uuid

            this.last_maintenance = lastMaintenanceText
            //this.last_maintenance_entrances = Math.floor(Math.random() * 10000)
            //this.last_maintenance_entrances = (this.item.last_maintenance) ? this.item.last_maintenance.entrances_since_last_maintenance : "N/A"
            this.formTitle = this.formTitle + " (ID: " + this.maintenance_schedule_group_id + ")"
            
        },

        demoSubmit() {
            let vm = this
            if(this.$refs.form.validate()) {
                vm.cancelText = "Cancel"
                vm.loading = true
                vm.backendValidationMessages = []
                vm.backendMessages = []
                vm.backendErrorMessages = []

                let randNumber = Math.floor(Math.random() * 2);

                setTimeout(() => {
                    vm.loading = false

                    if(randNumber == 0) {
                        vm.backendMessages.push('Maintenance record has been successfully entered into the system.');
                        vm.disableSubmit = true
                        vm.cancelText = "Close"

                    } else {
                        window.console.error("err")
                        vm.backendErrorMessages.push('Ups... Something went wrong :(')
                    }   

                    vm.loading = false

                }, 2500)
            }
        }


    },

    created() {
        let vm = this;
        EventBus.$on('ADD_MAINTENANCE_DIALOG', function(data) {
            //window.console.log(data)
            vm.item = data
            vm.current_date = getCurrentDateTime().date_time_formatted
            vm.servicemen = vm.$store.getters.user.name
            vm.device_name = vm.item.business_premise_name
            vm.last_maintenance = vm.item.last_maintenance
            vm.dialog = true;

            vm.setupData()

            //window.console.log("current date: ", vm.current_date);
        });
    },

    mounted() {

    },

    beforeDestroy() {
        this.item = {}
        EventBus.$off('ADD_MAINTENANCE_DIALOG')
    },

    destroyed() {

    }
}

</script> 

<style scoped>
    .v-card__title {
        background-color: #f5f5f5 !important;
    }

    #form--card--actions--desktop {
        padding:10px 24px 10px !important;
    }

    #form--card--actions--mobile {
        padding:20px 24px 20px !important;
    }
</style>

